export const ANALYTICS_URLS = '__TU_ANALYTICS_URLS__'
export const ANALYTICS_DATA = '__TU_ANALYTICS_DATA__'
